export const environment = {
    production: false,
    baseUrl: 'https://cep.controlexpert.expert/',
    apiEndpoint: 'https://cep.controlexpert.expert/api/EasyClaim/'
};
